module.exports = __webpack_public_path__ + "static/media/do.0ee72150.webp";